<template>
  <div>
     <div id="hamNav">
      <Slide @openMenu="handleOpenMenu">
        <router-link tag="li" to="/showroom">
          <span>Mountain Home</span>
        </router-link>
        <router-link tag="li" to="/showroomTwo">
          <span>Dado</span>
        </router-link>
        <router-link tag="li" to="/showroomThree">
          <span>Outdoor Project</span>
        </router-link>
        <router-link tag="li" to="/showroomFour">
          <span>Snoqualmie</span>
        </router-link>
      </Slide>
    </div>
     <aside class="showroomMenu">
    <ul>
      <li>
        <!-- <a @click='component = "showroomOne"'>Mountain Home Showroom</a> -->
        <router-link tag="a" to="/showroom">Mountain Home Showroom</router-link>
      </li>
      <li>
         <!-- <a @click='component = "showroomTwo"'>Dado Showroom</a> -->
          <router-link tag="a" to="/showroomTwo">Dado Showroom</router-link>
      </li>
      <li>
         <!-- <a @click='component = "showroomThree"'>Outdoor Projects Showroom</a> -->
          <router-link tag="a" to="/showroomThree">Outdoor Projects Showroom</router-link>
      </li>
      <li>
         <!-- <a @click='component = "showroomFour"'>Snoqualmie Showroom</a> -->
          <router-link tag="a" to="/showroomFour">Snoqualmie Showroom</router-link>
      </li>
    </ul>
  </aside>
    <component v-bind:is="component"></component>
  </div>
</template>

<script>
import ShowroomOne from '../../components/showroom/ShowroomOne'
import ShowroomTwo from '../../components/showroom/ShowroomTwo'
import ShowroomThree from '../../components/showroom/ShowroomThree'
import ShowroomFour from '../../components/showroom/ShowroomFour'
import { Slide } from 'vue-burger-menu'
export default {
  components: {
    showroomOne: ShowroomOne,
    showroomTwo: ShowroomTwo,
    showroomThree: ShowroomThree,
    showroomFour: ShowroomFour,
    Slide
  },
  methods: {},
  data (data) {
    return {
      component: 'showroomFour'
    }
  }
}
</script>

<style>
</style>
